export class InquiryRequest {
  public pageSize = 0;
  public pageNumber = 0;
  public withPaging = false;

  constructor() {}
}
